export function DistributorInformResultButton({
  processStatus,
  user: userType
}) {
  return (
    userType === 'distributor' &&
    processStatus === 'awaiting distributor result'
  );
}
